module.exports = __webpack_public_path__ + "static/media/motorhome_tomato.a870eeef.svg";